module.exports = __webpack_public_path__ + "static/media/how-it-works-golf-step-1.a0a57468.png";